
import createIcon from "./createIcon";

export const AIcon = createIcon('A', (props) => {
  return (
    <svg {...props}>
      <g>
        <path d="M12.74051318359375,13.049L11.18051318359375,13.049L10.12751318359375,10.046L6.5265131835937495,10.046L5.4735131835937505,13.049L3.91351318359375,13.049L7.5665131835937505,3L9.08751318359375,3L12.74051318359375,13.049ZM8.28151318359375,5.041L7.02051318359375,8.655000000000001L9.633513183593749,8.655000000000001L8.35951318359375,5.041L8.28151318359375,5.041Z" fill={props.color} fillOpacity="1" />
      </g>
    </svg >
  )
});
